const KEY_0 = 48;
const KEY_1 = 49;
const KEY_2 = 50;
const KEY_3 = 51;
const KEY_4 = 52;
const KEY_5 = 53;
const KEY_6 = 54;
export const HEADING_KEYS: number[] = [KEY_0, KEY_1, KEY_2, KEY_3, KEY_4, KEY_5, KEY_6];

const NUMPAD_KEY_0 = 96;
const NUMPAD_KEY_1 = 97;
const NUMPAD_KEY_2 = 98;
const NUMPAD_KEY_3 = 99;
const NUMPAD_KEY_4 = 100;
const NUMPAD_KEY_5 = 101;
const NUMPAD_KEY_6 = 102;
export const HEADING_NUMPAD_KEYS: number[] = [
	NUMPAD_KEY_0,
	NUMPAD_KEY_1,
	NUMPAD_KEY_2,
	NUMPAD_KEY_3,
	NUMPAD_KEY_4,
	NUMPAD_KEY_5,
	NUMPAD_KEY_6,
];
